import {RESPONSE_STATUS_CODE} from 'core/constants';
import {get404Exception} from 'core/exceptions/NotFoundException';
import {TAppInitialController} from 'core/redux/types';
import {isEmpty} from 'lodash';
import {getBreadCrumbsList} from 'modules/breadcrumbs/thunks';
import {selectCategoriesList} from 'modules/categories/selectors';
import {CategoryService} from 'modules/categories/services/CategoryService';
import {ProductCardService} from 'modules/product-card/services/ProductCardService';
import {getProduct} from 'modules/product-card/thunks';
import {getProductUrl} from 'modules/products/helpers';
import {getProductGroupsList} from 'modules/products/thunks';
import {ROUTER_QUERY_KEY} from 'modules/router/constants';
import {ProductGroupEnum} from 'new-models';

export const productControllerById: TAppInitialController<void> = async ({dispatch, getState}, ctx) => {
    const {query} = ctx;

    if (!query[ROUTER_QUERY_KEY]) {
        throw get404Exception();
    }

    const {productId, productCode} = ProductCardService.parseProductUrlPath(query[ROUTER_QUERY_KEY] as string);

    if (!productId) {
        throw get404Exception();
    }

    const productData = await dispatch(getProduct(productId));

    if (!productData || isEmpty(productData)) {
        throw get404Exception();
    }

    const {categoryId} = productData!.product;

    if (!categoryId) {
        throw get404Exception();
    }

    if (productData.product.code !== productCode) {
        ctx.res
            ?.writeHead(RESPONSE_STATUS_CODE.FOUND, {
                location: getProductUrl(productData.product),
            })
            .end();
    }

    const categoryList = selectCategoriesList(getState());
    const parentIdList = CategoryService.makeParentCategoryIdList(categoryId, [], categoryList);

    await Promise.allSettled([
        dispatch(getBreadCrumbsList(parentIdList, {isLastActive: true})),
        dispatch(getProductGroupsList(ProductGroupEnum.Viewed)),
        dispatch(getProductGroupsList(ProductGroupEnum.Similar, productId)),
    ]);
};
